const removeAt = <ArrayElement>(source: ArrayElement[], index: number): ArrayElement[] => {
  return [...source.slice(0, index), ...source.slice(index + 1)];
};

export default removeAt;
